module.exports = __webpack_public_path__ + "static/media/Thai_house.1a7dd781.obj";